import React from "react";
import { LuLanguages } from "react-icons/lu";
import { isEnglish, setLanguage } from "../../i18n";

// Arabic/English switch. The label names the language it will activate, in that language.
const LanguageToggle = ({ className = "" }) => {
  const label = isEnglish ? "التبديل إلى العربية" : "Switch to English";
  return (
    <button
      type="button"
      onClick={() => setLanguage(isEnglish ? "ar" : "en")}
      aria-label={label}
      title={label}
      lang={isEnglish ? "ar" : "en"}
      className={className}
    >
      <LuLanguages aria-hidden="true" />
      <span className="ms-1 text-sm font-semibold">{isEnglish ? "ع" : "EN"}</span>
    </button>
  );
};

export default LanguageToggle;
